import React, {useCallback, useState} from 'react';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import LeftTabbedGrayHeader from '../../../elements/headers/LeftTabbedGrayHeader';
import Scrollable from '../../../elements/Scrollable';
import TopBar from '../../../elements/TopBar/TopBar';
import Screen from '../../Screen';
import RecoverPasswordFlow from './innerComponents/RecoverPasswordFlow';
import RequestNewPassword from './innerComponents/RequestNewPassword';
import RequestOldPassword from './innerComponents/RequestOldPassword';

const ChangeUserPasswordScreen = props => {
    const {} = props,
        i18n = useI18n(),
        [oldPassword, setOldPassword] = useState(null),
        [recoverPasswordFlow, setRecoverPasswordFlow] = useState(false);

    const handleIDontKnowPassword = useCallback(() => {
        setRecoverPasswordFlow(true);
    }, []);
    const handleCancelPasswordRecovery = useCallback(() => {
        setRecoverPasswordFlow(false);
    }, []);

    const header = (
        <>
            <TopBar returnURL=".." />
            <hr />
        </>
    );

    return (
        <Screen header={header}>
            <Scrollable>
                <LeftTabbedGrayHeader>{i18n['label.word.change']}</LeftTabbedGrayHeader>
                <br />
                <br />
                {recoverPasswordFlow ? (
                    <RecoverPasswordFlow onCancel={handleCancelPasswordRecovery} />
                ) : !oldPassword ? (
                    <RequestOldPassword onChange={setOldPassword} onIDontKnowPassword={handleIDontKnowPassword} />
                ) : (
                    <RequestNewPassword oldPassword={oldPassword} />
                )}
            </Scrollable>
        </Screen>
    );
};

export default ChangeUserPasswordScreen;
